import styled from "styled-components";

export const Layout = styled.div<{ isVisible?: boolean; isLeader?: boolean }>`
  padding: 10px 8px;
  background-color: var(--menu-snow-background-color, var(--snow));
  box-shadow: var(--box-shadow)
    var(--menu-ebony-shadow-box-shadow-color, var(--ebony-shadow));
  border-radius: 2px;
  width: max-content;
  min-width: 280px;
  z-index: ${({ isLeader }) => (isLeader ? 99 : 98)};
  visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 0.1s ease-in-out;
  will-change: transform;
`;

export const Text = styled.div`
  font: normal 600 13px/18px "Open Sans";
  color: var(--header-ebony-color, var(--ebony));
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: 16px;
`;

export const Table = styled.table`
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
`;

export const TableRow = styled.tr<{ isActive?: boolean }>`
  height: 24px;
  font-size: 13px;
  line-height: 18px;
  color: var(--section-night-color, var(--night));
  background-color: transparent;
  font-weight: 400;

  ${({ isActive }) =>
    isActive
      ? "background-color:var(--menu-item-color-primary-100-background-color,var(--color-primary-100))"
      : ""};

  td:nth-child(1) {
    border-bottom-left-radius: 2px;
    border-top-left-radius: 2px;
  }
  td:last-child {
    border-bottom-right-radius: 2px;
    border-top-right-radius: 2px;
  }
  td {
    padding: 3px 8px;
  }
`;

export const Td = styled.td<{ bold?: boolean; setMinWidth?: boolean }>`
  ${({ bold }) => (bold ? "font-weight:600" : "")};
  ${({ setMinWidth: minWidth = true }) =>
    minWidth ? "min-width:58px;" : "min-width:auto"};
  & .bold {
    font-weight: 600;
  }
`;

export const TdMore = styled(Td)`
  color: var(--mode-text-neutral-weakest);
`;

export const DateTime = styled(Td)`
  font-weight: 400;
  color: var(--mode-text-neutral-weakest);
`;

export const Flex = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  .tip {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
